
import { Events, eventsManager } from "@rhinov/savane-js";
import { ResultsWidget } from "../ResultsWidget";
import { ResultsController } from "../Tools/ResultsController";
import { ResultsOverlayWidget } from "./ResultsOverlayWidget";
import { PlanManager, ActionStateEnum } from '@rhinov/cocos-plan';
import { _ASSET_TYPE, ARRMGR_CLOUDINARY_ALLOWED, ARRMGR_CLOUDINARY_URL, getMediaUrl } from "@rhinov/asset-manager-service";



export class ResourceWidget {
    static controller: ResultsController = new ResultsController();
    static hideTooltipListener: any;
    static stateListener: any;

    static resizeFunc() {
        ResultsWidget.hideTooltip();
        $('.resourceItem').each((_idx, element) => {
            $(element).css('height', ResultsWidget.itemSize + 'px');
            $(element).css('width', ResultsWidget.itemSize + 'px');
        });

    };

    static oldState: any = null;

    static html(resources: any[]): string {
        //Launch on start
        if (ResourceWidget.hideTooltipListener) {
            eventsManager.instance.removeListener(ResourceWidget.hideTooltipListener);
        }

        if (ResourceWidget.stateListener) {
            eventsManager.instance.removeListener(ResourceWidget.stateListener);
        }

        ResourceWidget.hideTooltipListener = eventsManager.instance.addListener(Events.HIDE_TOOLTIP_EVENT, () => ResultsWidget.hideTooltip());
        ResourceWidget.stateListener = eventsManager.instance.addListener(Events.PLAN_STATE_CHANGED, () => {
            const instance = PlanManager.getInstance();
            if (ResourceWidget.oldState === instance.getAction()) return;
            if (instance.getAction() === ActionStateEnum.idleDecoration && ResourceWidget.oldState === ActionStateEnum.DrawWorkTop) {
                setTimeout(() => {
                    ResourceWidget.controller.destroy();
                    ResultsWidget.controller.destroy();
                    ResultsWidget.html();
                });
            } else if (instance.getAction() === ActionStateEnum.DrawWorkTop) {
                ResultsWidget.controller.destroy();
                ResourceWidget.controller.destroy();
            } else return;
            ResourceWidget.oldState = instance.getAction();
            ResultsWidget.hideTooltip();
        });
        $(window).on('resize', ResourceWidget.resizeFunc);

        let resultHtml = '';
        if (resources === null || resources === undefined || resources.length === 0) {
            return resultHtml;
        }
        resources.forEach((resource) => {
            resultHtml += `
            <div class="resourceItem listResults-${resource._id}"
                style="background-color: #efefef; background-position: 50% 50%; background-size: cover;">
            `;
            let overlay = new ResultsOverlayWidget(ResultsOverlayWidget.openUrl, ResultsWidget.openDetailsFunc || (() => {}), resource);
            resultHtml += overlay.html() + '</div>';
            setTimeout(() => {
                ResourceWidget.controller.addEventListeners('mouseenter', (event) => { ResultsWidget.displayTooltip(resource, event) }, `listResults-${resource._id}`, undefined, true);
                ResourceWidget.controller.addEventListeners('mouseleave', () => { ResultsWidget.hideTooltip() }, `listResults-${resource._id}`, undefined, true);
                ResourceWidget.controller.addEventListeners('mousedown', () => { ResultsWidget.startDrag(resource); }, `listResults-${resource._id}`, undefined, true);

                const elements = document.querySelectorAll(`.listResults-${resource._id}`);
                if (elements.length !== 0) {
                    elements.forEach((elem) => {
                        ($(elem) as any).draggable({
                            revert: 'valid',
                            helper: 'clone',
                        });
                    })
                }
                setTimeout(() => {
                    ResourceWidget.setResourceUrl(resource);
                });
            });
        });
        setTimeout(() => {
            ResourceWidget.resizeFunc();
        });
        return resultHtml;
    }

    static removeListeners(resources: any[] | null) {
        if (resources === null) return;
        resources.forEach((resource) => {
            ResourceWidget.controller.removeEventListeners('mouseenter', `listResults-${resource._id}`);
            ResourceWidget.controller.removeEventListeners('mouseleave', `listResults-${resource._id}`);
            ResourceWidget.controller.removeEventListeners('mousedown', `listResults-${resource._id}`);
            const elements = document.querySelectorAll(`.listResults-${resource._id}`);
            if (elements.length !== 0) {
                elements.forEach((elem) => {
                    const $elem = $(elem) as any;
                    if ($elem.draggable) {
                        $elem.draggable('destroy');
                    }
                })
            }
        });
    }

    static setResourceUrl(resource: any) {
        if (resource === undefined || resource === null) return;
        const decorService = ResultsWidget.getDecorationService();
        if (!decorService) return;
        var configIndex = decorService.getFilteredConfig(resource);
        var filename: string;
        var path: string;

        eventsManager.instance.dispatch(Events.STOP_UPDATING_ENVS);
        //Search in media the default preview
        switch (decorService.group) {
            case _ASSET_TYPE.ARRANGEMENTS:
            case _ASSET_TYPE.PRODUCTS:
                filename = 'preview' + configIndex + '-sm.webp';
                if (getMediaUrl().indexOf("media") === -1) {
                    path = 'assets';
                }
                else {
                    path = 'arrangements';
                }
                break;

            case _ASSET_TYPE.JOINERIES:
                filename = 'preview1-sm.webp';
                path = 'joineries';
                break;

            case _ASSET_TYPE.TECHNICAL_ELEMENTS:
                filename = 'preview1-sm.webp';
                path = 'technicalelements';
                break;

            case _ASSET_TYPE.TEMPLATES:
                filename = 'preview1-sm.webp';
                path = 'assets_groups';
                break;

            case _ASSET_TYPE.COATINGS:
                filename = 'preview' + configIndex + '-sm.webp';
                path = 'coatings';
                break;

            case _ASSET_TYPE.ALL:
                filename = 'preview' + configIndex + '-sm.webp';
                path = 'allAssets';
                break;

            case 'nextobjects':
            case 'magicsearch':
                switch (resource.kind) {
                    case 'Arrangement':
                        filename = 'preview' + configIndex + '-sm.webp';
                        if (getMediaUrl().indexOf("media") === -1) {
                            path = 'assets';
                        }
                        else {
                            path = 'arrangements';
                        }
                        break;

                    case 'Joinery':
                        filename = 'preview1-sm.webp';
                        path = 'joineries';
                        break;

                    case 'TechnicalElement':
                        filename = 'preview1-sm.webp';
                        path = 'technicalelements';
                        break;

                    case 'Template':
                        filename = 'preview1-sm.webp';
                        path = 'assets_groups';
                        break;

                    case 'Coating':
                        filename = 'preview' + configIndex + '-sm.webp';
                        path = 'coatings';
                        break;

                    default:
                        filename = '';
                        path = '';
                        break;
                }
                break;
            default:
                filename = '';
                path = '';
                break;
        }
        // var url = getUrl() + 'api/v1/' + path + '/' + resource._id + '/medias/previews/' + filename; //resource.medias[imgIndex];

        // Old media server
        var url = getMediaUrl() + path + '/' + resource._id + '/medias/previews/' + filename;
        // New cloudinary
        if (ARRMGR_CLOUDINARY_ALLOWED) {
            url = ARRMGR_CLOUDINARY_URL + resource._id + '/medias/previews/' + filename;
        }
        let elements = document.querySelectorAll(`.listResults-${resource._id}`);
        let element = elements.item(elements.length - 1);

        $(element).css({
            'background-image': 'url(' + url + ')'
        });
        setTimeout(() => {
            let elements = document.querySelectorAll(`#empty-${resource._id}`);
            let element = elements.item(elements.length - 1);
            $(element).css('display', '');
        });
        eventsManager.instance.dispatch(Events.START_UPDATING_ENVS);
    }

    static destroy() {
        eventsManager.instance.removeListener(ResourceWidget.hideTooltipListener);
        eventsManager.instance.removeListener(ResourceWidget.stateListener);
        ResourceWidget.hideTooltipListener = null;
        ResourceWidget.stateListener = null;
        $(window).off('resize', ResourceWidget.resizeFunc);
        ResourceWidget.controller.destroy();
    }
}